import { useTranslation } from '../../../../../translations';
import { useOpen } from '../../../../../hooks/useOpen';

export default function useCallLink({ link }) {
  const { t } = useTranslation();
  const open = useOpen();
  return {
    callLink() {
      link && open(t(link, { defaultValue: link }));
    },
  };
}
